module.exports = __webpack_public_path__ + "static/media/rejected-file.d2847db3.svg";